/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TemplateRecommendedReleases,
    TemplateRecommendedReleasesFromJSON,
    TemplateRecommendedReleasesFromJSONTyped,
    TemplateRecommendedReleasesToJSON,
} from './TemplateRecommendedReleases';

/**
 * GET /templates/{template_id}/recommended_releases
 * @export
 * @interface GetTemplateRecommendedReleasesSuccessResponse
 */
export interface GetTemplateRecommendedReleasesSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTemplateRecommendedReleasesSuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetTemplateRecommendedReleasesSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {TemplateRecommendedReleases}
     * @memberof GetTemplateRecommendedReleasesSuccessResponse
     */
    data: TemplateRecommendedReleases;
}

export function GetTemplateRecommendedReleasesSuccessResponseFromJSON(json: any): GetTemplateRecommendedReleasesSuccessResponse {
    return GetTemplateRecommendedReleasesSuccessResponseFromJSONTyped(json, false);
}

export function GetTemplateRecommendedReleasesSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTemplateRecommendedReleasesSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': TemplateRecommendedReleasesFromJSON(json['data']),
    };
}

export function GetTemplateRecommendedReleasesSuccessResponseToJSON(value?: GetTemplateRecommendedReleasesSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': TemplateRecommendedReleasesToJSON(value.data),
    };
}

